import type React from "react";
import {Stack, Typography} from "@mui/material";
import {daysUntil, EMPTY_CELL} from "~/components/data-grid/cells/gridCellFormat";
import {MONO_FONT} from "~/style/fonts";


/** Vertically centres a cell's stacked content — main value plus sub-line. */
export function centered(children: React.ReactNode) {
    return <Stack sx={{justifyContent: 'center', height: '100%'}}>{children}</Stack>;
}

/** Sub-line under a cell's main value. */
export function subLine(content: React.ReactNode, color = 'text.secondary', isMonospace = false) {
    return (
        <Typography variant="caption" color={color} sx={{display: 'block', lineHeight: 1.3, fontFamily: isMonospace ? MONO_FONT : 'inherit'}}>
            {content}
        </Typography>
    );
}

/** A cell for a column with no value — e.g. one the API has no data for yet. */
export function emptyCell() {
    return centered(<Typography variant="body2" color="text.secondary">{EMPTY_CELL}</Typography>);
}

/** Days-to-date sub-line: "N d left", amber within 60 days, red "N d overdue" once past. */
export function daysLeftLine(date: string | null, isMonospace = true) {
    const days = daysUntil(date);
    if (days === null) return subLine(EMPTY_CELL);
    const color = days < 0 ? 'error.main' : days <= 60 ? 'warning.main' : 'text.secondary';
    return subLine(days < 0 ? `${Math.abs(days)}d overdue` : `${days}d left`, color, isMonospace);
}
